// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","7295":"6de64f17","7483":"6de64f17","7522":"6de64f17","7871":"2f0945dc"}[chunkId] + ".chunk.css";
};